import { render, staticRenderFns } from "./TextArea.form-builder.vue?vue&type=template&id=b2c0de0c&"
import script from "./TextArea.form-builder.vue?vue&type=script&lang=js&"
export * from "./TextArea.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports